module.exports = __webpack_public_path__ + "img/banner1.290ff933.jpg";